module.exports = __webpack_public_path__ + "img/FR14707.7707b1f6.png";